/* eslint-disable max-lines */
import {
  ArrowsRightLeftIcon,
  ChatBubbleOvalLeftEllipsisIcon,
  CheckCircleIcon,
  ClockIcon,
  StarIcon,
  XCircleIcon
} from "@heroicons/react/24/outline";
import { FC } from "react";
import { IReservationV2 } from "../../interfaces/reservations/Reservations.types";
import { TicketStatusEnum } from "../reservations/res.enum";
import Passengers from "../shared/svgs/Passengers";
import InsertDate from "./InsertDate";

interface PaymentInfoProps {
  paymentStatus: IReservationV2["paymentStatus"];
  paymentMethodId: IReservationV2["paymentMethodId"];
  price: IReservationV2["price"];
  clientNames: IReservationV2["clientNames"];
  insertDate?: IReservationV2["insertDate"]; // Make it optional using "?"
  conciergeName?: IReservationV2["conciergeName"];
  flexType?: IReservationV2["flexType"];
  hasTextMeMyTrip?: IReservationV2["hasTextMeMyTrip"];
  hasOpenReturn?: IReservationV2["hasOpenReturn"];
  cancellationSource?: IReservationV2["cancellationSource"];
}

const PaymentInfo: FC<PaymentInfoProps> = ({
  paymentStatus,
  paymentMethodId,
  price,
  clientNames,
  insertDate,
  conciergeName,
  flexType,
  hasTextMeMyTrip,
  hasOpenReturn,
  cancellationSource
}) => {

  const showAdminCancellationBadge =
    paymentStatus === TicketStatusEnum.Canceled &&
    cancellationSource === "admin";

  return (
    <div className="col-start-7 col-span-4 row-start-1 flex flex-col space-x-4">
      <div className="flex justify-end">
        {clientNames.length && clientNames.length > 1 ? (
          <div className="flex items-center mr-5">
            <div className="flex">
              <p className="mr-1 text-sm">{clientNames.length}</p>
              <span className="w-4 h-4">
                <Passengers />
              </span>
            </div>
          </div>
        ) : null}
        <div
          className={`${
            (paymentStatus === 1 &&
              "bg-green text-white px-1 py-0.5 rounded-lg text-[13px]") ||
            (paymentStatus === 2 &&
              "bg-orange text-white px-1 py-0.5 rounded-lg text-[13px]") ||
            (paymentStatus === 3 &&
              "bg-red text-white px-1 py-0.5 rounded-lg text-[13px]") ||
            (paymentStatus === 4 &&
              "bg-blue text-white px-1 py-0.5 rounded-lg text-[13px]")
          }`}
        >
          {paymentMethodId ? (
            <div
              className="rounded-lg flex justify-center items-center"
              title={`${
                (paymentStatus === 1 && "I Konfirmuar") ||
                (paymentStatus === 2 && "I Pa përfunduar") ||
                (paymentStatus === 3 && "I Anuluar") ||
                (paymentStatus === 4 && "I Rimbursuar")
              }`}
            >
              <div className="inline-flex items-center w-max" title="Totali">
                {price}€
              </div>
              <span className="mx-2 rounded-full bg-white p-[1.5px]" />
              {paymentMethodId === 2 && (
                <span className="whitespace-nowrap">Stripe</span>
              )}
              {paymentMethodId === 1 && (
                <span className="whitespace-nowrap">RBKO</span>
              )}
              {paymentMethodId === 7 && (
                <span className="whitespace-nowrap">NLB</span>
              )}
              {paymentStatus === 1 && (
                <CheckCircleIcon className="w-4 h-4 ml-1" />
              )}
              {paymentStatus === 3 && <XCircleIcon className="w-4 h-4 ml-1" />}
              {paymentStatus === 4 && <XCircleIcon className="w-4 h-4 ml-1" />}
            </div>
          ) : (
            <span className="whitespace-nowrap flex items-center">
              I Pa përfunduar <ClockIcon className="w-4 h-4 ml-1" />
            </span>
          )}
        </div>
      </div>
      <div className="flex justify-end items-center gap-2">
        {showAdminCancellationBadge && (
          <div className="inline-flex items-center px-2 py-0.5 rounded
          border border-red-300 bg-red-100/50 text-red-700 text-xs font-semibold">
            <span>Admin</span>
          </div>
        )}
        {(hasOpenReturn ||
          conciergeName ||
          (flexType && flexType !== "NotRefundable")) && (
          <div className="flex gap-1 mt-1 justify-end">
            {hasOpenReturn && (
              <div className="inline-flex items-center gap-1 px-2 py-0.5 rounded
              text-[11px] text-white bg-warning-300">
                <ArrowsRightLeftIcon className="w-3 h-3 text-white" />
                <span>Open return</span>
              </div>
            )}
            {conciergeName && (
              <div className="inline-flex items-center gap-1 bg-blue-100
             text-amber-700 px-2 py-0.5 rounded text-xs">
                <StarIcon className="w-3 h-3 text-secondary fill-primary" />
                <span>Concierge</span>
              </div>
            )}
            {flexType && flexType !== "NotRefundable" && (
              <div className="inline-flex items-center gap-1 bg-orange-100/50
            text-blue-700 px-2 py-0.5 rounded text-xs">
                <ArrowsRightLeftIcon className="w-3 h-3 text-secondary" />
                <span>{flexType}</span>
              </div>
            )}
          </div>
        )}
        {hasTextMeMyTrip && (
          <div className="flex gap-1 mt-1 justify-end">
            <div className="inline-flex items-center gap-1 bg-blue-300
             text-white px-2 py-0.5 rounded text-xs">
              <ChatBubbleOvalLeftEllipsisIcon className="w-3.5 h-3.5 text-white " />
              <span>SMS</span>
            </div>
          </div>
        )}
      </div>
      {insertDate && <InsertDate insertDate={insertDate} />}
    </div>
  );
};

export default PaymentInfo;
